var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"containerComponent"},[_c('Header'),_c('AppMain'),_c('Bottom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }